import { message, Select, Alert, Switch } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  SelectItem,
  SelectEscuelasItem,
  ErrorItem,
} from "../../../../Components/Items";

const { Option } = Select;

class GrupoEscuelaModal extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    objetoNiveles: [],
    objetoProgramas: [],
    objetoListas: [],
    nivelesCount: 0,
    programasCount: 0,
    catalogosCargados: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      if (this.formRef.current) this.formRef.current.resetFields();
      this.setState({
        catalogosCargados: false,
        nivelesCount: 0,
        programasCount: 0,
      });
      this.cargarCatalogos();
      if (this.props.grupo?._id) {
        this.consultarDatos(this.props.grupo._id);
      } else if (this.props.escuelaIdInicial) {
        this.formRef.current?.setFieldsValue({
          escuelaId: this.props.escuelaIdInicial,
        });
      }
    }
  }

  esEdicion = () => Boolean(this.props.grupo?._id);

  cargarCatalogos = async () => {
    try {
      const [resN, resP /* , resL */] = await Promise.all([
        axios.post(
          "nivelesEducativos/selectNivelesEducativos",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        ),
        axios.post(
          "programasEducativos/selectProgramasEducativos",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        ),
        // axios.post(
        //   "listasEscuela/selectListasEscuelaItem",
        //   { empresaId: this.props.empresaId },
        //   { headers: this.props.headersToken }
        // ),
      ]);
      const niveles = resN.data.data || [];
      const programas = resP.data.data || [];
      this.setState({
        nivelesCount: niveles.length,
        programasCount: programas.length,
        catalogosCargados: true,
        objetoNiveles: niveles.map((v) => (
          <Option key={v._id} value={v._id}>
            {v.nombre}
          </Option>
        )),
        objetoProgramas: programas.map((v) => (
          <Option key={v._id} value={v._id}>
            {v.nombre}
          </Option>
        )),
        // objetoListas: (resL.data.listas || []).map((v) => (
        //   <Option key={v._id} value={v._id}>
        //     {v.nombre}
        //   </Option>
        // )),
      });
    } catch (e) {
      this.setState({ catalogosCargados: true });
    }
  };

  consultarDatos = (id) => {
    this.setState({ loading: true });
    axios
      .post(
        "gruposEscuela/datosGrupoEscuela",
        { grupoEscuelaId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2 && res.data.grupo) {
          const {
            nombre,
            escuelaId,
            nivelEducativoId,
            grado,
            programaEducativoId,
            // listaId,
            envioListaLibrosDiaria,
            noEnviarCorreosEcommerce,
          } = res.data.grupo;
          this.formRef.current.setFieldsValue({
            nombre,
            escuelaId,
            nivelEducativoId,
            grado,
            programaEducativoId,
            // listaId,
            envioListaLibrosDiaria: {
              activo: Boolean(envioListaLibrosDiaria?.activo),
              correosEnvio: envioListaLibrosDiaria?.correosEnvio || [],
            },
            noEnviarCorreosEcommerce: Boolean(noEnviarCorreosEcommerce),
          });
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  onFinish = (values) => {
    if (!values?.nombre || !values?.escuelaId) {
      message.info("Nombre y escuela son requeridos");
      return;
    }
    this.setState({ loading: true });
    const url = this.esEdicion()
      ? "gruposEscuela/editarGrupoEscuela"
      : "gruposEscuela/agregarGrupoEscuela";
    const payload = this.esEdicion()
      ? { ...values, grupoEscuelaId: this.props.grupo._id }
      : { ...values, empresaId: this.props.empresaId };

    if ("listaId" in payload) delete payload.listaId;

    axios
      .post(url, payload, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            this.esEdicion() ? "Grupo actualizado" : "Grupo agregado"
          );
          this.cerrarModal(true);
        } else {
          message.error("No se pudo guardar");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  };

  cerrarModal = (recargar = false) => {
    if (this.formRef.current) this.formRef.current.resetFields();
    this.props.cerrarModal(recargar);
  };

  render() {
    const { catalogosCargados, nivelesCount, programasCount } = this.state;
    const faltanCatalogos =
      catalogosCargados && (nivelesCount === 0 || programasCount === 0);

    if (faltanCatalogos) {
      const faltantes = [];
      if (nivelesCount === 0) faltantes.push("niveles educativos");
      if (programasCount === 0) faltantes.push("programas educativos");
      return (
        <ModalItem
          title={this.esEdicion() ? "Editar Grupo" : "Agregar Grupo"}
          visible={this.props.visible}
          onCancel={() => this.cerrarModal(false)}
          width={600}
        >
          <Alert
            type="warning"
            showIcon
            message="Faltan catálogos para crear grupos"
            description={
              <span>
                Antes de crear un grupo necesitas dar de alta al menos un
                registro en <b>{faltantes.join(" y ")}</b>. Cierra este modal y
                ve a la pestaña Escuela → botón
                {faltantes.length === 1
                  ? ` ${nivelesCount === 0 ? '"Niveles Educativos"' : '"Programas Educativos"'}`
                  : ' "Niveles Educativos" / "Programas Educativos"'}
                .
              </span>
            }
          />
        </ModalItem>
      );
    }

    return (
      <ModalItem
        title={this.esEdicion() ? "Editar Grupo" : "Agregar Grupo"}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrarModal(false)}
        width={600}
      >
        <Form
          ref={this.formRef}
          name="modalGrupoEscuela"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              className="botonAgregar"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish}
          onFinishFailed={(e) => ErrorItem(e)}
        >
          <FormItem name="nombre" label="Nombre" required margin>
            <InputItem placeholder="Ej: Grupo A" />
          </FormItem>
          <FormItem name="escuelaId" label="Escuela" required margin>
            <SelectEscuelasItem
              placeholder="Selecciona la escuela"
              empresaId={this.props.empresaId}
              headersToken={this.props.headersToken}
            />
          </FormItem>
          <FormItem name="nivelEducativoId" label="Nivel Educativo" required margin>
            <SelectItem placeholder="Selecciona un nivel">
              {this.state.objetoNiveles}
            </SelectItem>
          </FormItem>
          <FormItem name="grado" label="Grado" margin>
            <InputItem placeholder="Ej: 3°" />
          </FormItem>
          <FormItem name="programaEducativoId" label="Programa Educativo" required margin>
            <SelectItem placeholder="Selecciona un programa">
              {this.state.objetoProgramas}
            </SelectItem>
          </FormItem>
          {/*
          <FormItem name="listaId" label="Lista" margin>
            <SelectItem placeholder="Selecciona una lista" allowClear>
              {this.state.objetoListas}
            </SelectItem>
          </FormItem>
          */}

          <FormItem
            name={["envioListaLibrosDiaria", "activo"]}
            label="Enviar lista diaria de libros asignados"
            margin
            valuePropName="checked"
            tooltip="Cada madrugada se envía un PDF con los alumnos de este grupo a los que se les asignó la clave de su libro el día anterior."
            wrapperLabel = {{ span: 6 }}
            labelCol = {{ span: 18 }}
          >
            <Switch />
          </FormItem>

          <FormItem shouldUpdate={(prev, curr) => prev.envioListaLibrosDiaria?.activo !== curr.envioListaLibrosDiaria?.activo} noStyle>
            {({ getFieldValue }) =>
              getFieldValue(["envioListaLibrosDiaria", "activo"]) ? (
                <FormItem
                  name={["envioListaLibrosDiaria", "correosEnvio"]}
                  label="Correos destinatarios"
                  margin
                  tooltip="Escribe un correo y presiona Enter para agregarlo"
                >
                  <SelectItem mode="tags" placeholder="correo@ejemplo.com" style={{ width: "100%" }} />
                </FormItem>
              ) : null
            }
          </FormItem>

          <FormItem
            name="noEnviarCorreosEcommerce"
            label="No enviar correos de ecommerce"
            margin
            valuePropName="checked"
            tooltip="Si se activa, los alumnos de este grupo no recibirán ningún correo automático generado por el ecommerce (pedido recibido, pago confirmado, cambios de estado de envío, libro virtual)."
            wrapperLabel={{ span: 6 }}
            labelCol={{ span: 18 }}
          >
            <Switch />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(GrupoEscuelaModal);
